export const TEST_RETURN_STATUS = {
    SUCESS: 1, // 测试成功
    ERROR_EMPTY_OBJECT: 2, // 空对象失败(未安装)
    ERROR_CONNECT: 3, // 心跳包空
    ERROR_START: 4, // 启动失败
    ERROR_RECIVE: 5, // 接收失败
}